import React, {useEffect} from 'react';
import {Carousel} from 'react-bootstrap';

import './styles.scss';

interface AppCarouselProps {
  className?: string;
  items: any;
  renderCarouselItem: Function;
  renderDirectionIcons?: Function | undefined;
  activeIndex?: number;
  onSelect?: any;
  indicatoresClass?: string;
  componentIndex: number;
  setComponentIndex(value: number): void;
}

const AppCarousel = ({
  className,
  items,
  renderCarouselItem,
  renderDirectionIcons,
  activeIndex,
  onSelect,
  indicatoresClass,
  componentIndex,
  setComponentIndex,
}: AppCarouselProps) => {
  const handleSelect = (selectedIndex: number) => {
    console.log(selectedIndex);

    setComponentIndex(selectedIndex);

    onSelect && onSelect(selectedIndex);
  };

  return (
    <Carousel
      activeIndex={activeIndex || componentIndex}
      onSelect={handleSelect}
      interval={null}
      controls={false}
      className={className}
      indicators={!!indicatoresClass ? false : true}
      prevIcon={renderDirectionIcons && renderDirectionIcons('prev')}
      nextIcon={renderDirectionIcons && renderDirectionIcons('next')}>
      {items.map((item: any, index: number) => (
        <Carousel.Item key={index}>{renderCarouselItem(item)}</Carousel.Item>
      ))}
    </Carousel>
  );
};

export default AppCarousel;
